export const tileSource = 'es_mvt'
export const outlineTileLayer = 'es_mvt_outline'
export const tileLayer = 'es_mvt_layer'

const landTileLayer = {
  id: tileLayer,
  type: 'fill',
  source: tileSource,
  minzoom: 13,
  'source-layer': 'hits',
  paint: {
    'fill-outline-color': 'rgb(0, 0, 0)',
  },
}

const tileLayerOutlined = (is3d: boolean) => {
  return {
    id: outlineTileLayer,
    type: 'line',
    source: tileSource,
    minzoom: 13,
    'source-layer': 'hits',
    paint: {
      'line-color': 'rgb(0, 0, 0)',
      'line-width': is3d ? 0 : 0.2,
    },
  }
}

const buildingTileLayer = (is3d: boolean) => ({
  id: tileLayer,
  type: is3d ? 'fill-extrusion' : 'fill',
  source: tileSource,
  minzoom: 13,
  'source-layer': 'hits',
  paint: is3d
    ? {
        'fill-extrusion-color': '#fff',
        'fill-extrusion-opacity': 1,
        'fill-extrusion-height': [
          'coalesce',
          ['get', 'height_estimate'],
          ['get', 'height'],
          ['*', ['get', 'floor_nb'], 3],
        ],
      }
    : {
        'fill-color': '#fff',
        'fill-opacity': 1,
        'fill-outline-color': 'rgb(0, 0, 0)',
      },
})

export { landTileLayer, buildingTileLayer, tileLayerOutlined }
